import { useQuery } from '../../index.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getHasChatsKey } from '../../utils/keys/messaging.key.js'

export const useHasChats = () => {
  const { client } = useTribeClient()
  const hasChatsKey = getHasChatsKey()

  return useQuery<boolean>(hasChatsKey, async () => {
    const chats = await client.messaging.chats({
      archived: false,
      limit: 1,
    })

    if (chats.data.length > 0) {
      return true
    }

    const archivedChats = await client.messaging.chats({
      archived: true,
      limit: 1,
    })

    return archivedChats.data.length > 0
  })
}
